
import { Vue, Component, Prop } from "vue-property-decorator";
import { AmCard, AmCardBody } from "@afe/amui/src/components/Card";
import { AmTypography } from "@afe/amui/src/components/Typography";
import { AmButton } from "@afe/amui/src/components/Button";
import { AmSpacing } from "@afe/amui/src/components/Spacing";
import { required } from "vuelidate/lib/validators";
import RestorePasswordByEmailLink from "@/forms/LoginForm/RestorePasswordByEmailLink.vue";
import RestorePasswordCallMe from "@/forms/LoginForm/RestorePasswordCallMe.vue";
import SuccessCallMe from "@/forms/LoginForm/SuccessCallMe.vue";
import {
  FormField,
  TextField,
  Preloader,
  FormError,
  FormSubmit
} from "../components";
import { makeAnalytics } from "../analytics";
import {
  resetPasswordByPhoneProceed,
  resetPasswordByPhone,
  RESET_PASSWORD_STEPS
} from "../service";

const ONE_MINUTE = 60000;

@Component({
  validations: {
    code: {
      required
    }
  },
  components: {
    RestorePasswordByEmailLink,
    AmCard,
    AmTypography,
    AmCardBody,
    FormField,
    TextField,
    AmSpacing,
    AmButton,
    Preloader,
    FormError,
    FormSubmit,
    RestorePasswordCallMe,
    SuccessCallMe
  }
})
export default class extends Vue {
  @Prop(Object) readonly config!: any;
  @Prop(Object) readonly formData!: any;

  code = "";
  isError = false;
  loading = false;
  loginUrl = "";
  analytics = makeAnalytics();

  timer = 0;
  delayCounter = 0;
  disableResend = false;
  callMeSuccess = false;
  startupDelay = this.formData.startupDelay || 0;
  phoneNumber = (this.formData && this.formData.phone_number) || "";

  beforeMount() {
    this.startSmsTimer(this.startupDelay);
  }
  beforeDestroy() {
    clearInterval(this.timer);
  }

  startSmsTimer(delay: number) {
    this.delayCounter = delay;
    this.timer = window.setInterval(this.countDown.bind(this), 1000);
  }

  async sendSmsWithDelay() {
    this.disableResend = true;

    resetPasswordByPhone({
      phone_number: this.formData.phone_number
    }).catch(({ data }) => {
      if (data && data.retryAfter) {
        this.startSmsTimer(data.retryAfter);
        return;
      }
      this.isError = true;
    });
    this.disableResend = false;
  }

  countDown() {
    if (this.delayCounter <= 0) {
      clearInterval(this.timer);
      this.delayCounter = 0;
      return;
    }

    this.delayCounter--;
  }

  onPrevStep() {
    this.$emit("prevStep");
  }

  onSubmit() {
    this.$v.$touch();

    if (this.$v.$invalid) {
      return;
    }

    this.isError = false;
    this.loading = true;
    this.disableResend = true;

    const data = {
      phone_number: this.formData.phone_number || "",
      code: this.code
    };

    resetPasswordByPhoneProceed(data)
      .then(({ next, response }) => {
        if (next === RESET_PASSWORD_STEPS.REDIRECT_STEP) {
          window.location.assign(response.data.activation_url);
        }
      })
      .catch(err => {
        this.isError = true;
        this.loading = false;
      });
  }

  async callMe() {
    this.disableResend = true;

    resetPasswordByPhone({
      phone_number: this.formData.phone_number,
      voice_call: true
    })
      .then(() => {
        this.callMeSuccess = true;
        setTimeout(() => {
          this.callMeSuccess = false;
        }, ONE_MINUTE);
      })
      .catch(({ data }) => {
        if (data && data.retryAfter) {
          this.startSmsTimer(data.retryAfter);
          return;
        }
        this.isError = true;
      });
    this.disableResend = false;
  }

  get isWaiting() {
    return this.delayCounter > 0;
  }

  get disableSubmit() {
    return this.code.length !== 6;
  }
}
